import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { AssetOrder } from '../models/entities/asset-order';
import { AssetOrderRequest } from '../models/dto/asset-order_request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


@Injectable({
  providedIn: 'root'
})
export class AssetOrderService {

  constructor(
    private networkService: LeanNetworkService,  
    public userService : UserService) { }


  assetOrdersGet(code : string, d1 : Date, d2 : Date, excludeClosed  : boolean) : Promise<AssetOrder[]> {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;
    request.dteArg1 = d1;
    request.dteArg2 = d2;
    request.blnArg1 = excludeClosed;

    
    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetOrdersGet', request).then(result => {
          return resolve(result.assetOrders);
        }, error => {
            reject(error);
        });
    });
  }

  assetOrderGet(code : string) : Promise<AssetOrder> {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetOrderGet', request).then(result => {
          return resolve(result.assetOrder);
        }, error => {
            reject(error);
        });
    });
  }


  assetOrderSave(assetOrder : AssetOrder) : Promise<AssetOrder>{
    let request: AssetOrderRequest = new AssetOrderRequest(this.userService.userInfo);
    request.assetOrder = assetOrder;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetOrderSave', request).then(result => {
            let assetOrder : AssetOrder = result.assetOrder;
            return resolve(assetOrder);         
        }, error => {
            reject(error);
        });
    });
}


assetOrderReception(assetOrder : AssetOrder) : Promise<AssetOrder>{
  let request: AssetOrderRequest = new AssetOrderRequest(this.userService.userInfo);
  request.assetOrder = assetOrder;

  return new Promise((resolve, reject) => {
      this.networkService.post('services/logistics/assetOrderReception', request).then(result => {
          return resolve(result.assetOrder);         
      }, error => {
          reject(error);
      });
  });
}


assetOrderBufferize(assetOrder : AssetOrder) : Promise<Boolean>{
  let request: AssetOrderRequest = new AssetOrderRequest(this.userService.userInfo);
  request.assetOrder = assetOrder;

  return new Promise((resolve, reject) => {
      this.networkService.post('services/logistics/assetOrderBufferize', request).then(result => {
          return resolve(true);         
      }, error => {
          reject(error);
      });
  });
}

}

